export const excludedBundleAssets: string[] = ['USDT', 'USDC', 'BUSD', 'UST', 'DAI', 'WBTC', 'FTT'];
